function handleRegister () {
  const ref = localStorage.getItem('ref')
  const refQueryString = ref !== null ? `?refId=${ref}` : ''
  window.location.href = `https://app.orionx.com/register${refQueryString}`
  localStorage.removeItem('ref')
}

export default handleRegister
